import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { setExternalUserInfo, getUserInfo, handleLogin } from '../../services/apiClient';

export default function ExternalEntryPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingUrl, setPendingUrl] = useState(null);
  const [pendingName, setPendingName] = useState(null);

  useEffect(() => {
    const returnUrl = searchParams.get('return_url');
    const returnName = searchParams.get('return_name');
    const user_info = getUserInfo();

    if (returnUrl) {
      const allowed = isAllowedReturnUrl(returnUrl);
      if (allowed) {
        setExternalUserInfo({ url: returnUrl, name: returnName });
        if (!user_info) {
          // Зберігаємо параметри і показуємо модалку
          setPendingUrl(returnUrl);
          setPendingName(returnName);
          setShowAuthModal(true);
        } else {
          navigate('/profile');
        }
      } else {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  }, []);

  const handleModalClose = () => {
    setShowAuthModal(false);
    handleLogin();
  };

  return (
    <>
      <div>Зачекайте...</div>

      {/* Bootstrap Modal */}
      {showAuthModal && (
        <>
          <div
            className="modal fade show"
            style={{ display: 'block' }}
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="authModalLabel"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="authModalLabel">
                    Авторизація
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleModalClose}
                  />
                </div>
                <div className="modal-body">
                  <div className="d-flex align-items-center gap-3">
                    <i className="bi bi-person-lock fs-2 text-primary" />
                    <p className="mb-0">
                      Необхідно пройти авторизацію для подання заявки.
                    </p>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleModalClose}
                  >
                    Увійти
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Backdrop */}
          <div className="modal-backdrop fade show" />
        </>
      )}
    </>
  );
}

function isAllowedReturnUrl(url) {
  try {
    const parsed = new URL(url);
    const allowedHosts = ['portal.kyiv.digital', 'portal-stage.kyiv.digital'];
    return allowedHosts.includes(parsed.hostname);
  } catch {
    return false;
  }
}